import { render, staticRenderFns } from "./AllOrders.vue?vue&type=template&id=703a06a8&scoped=true"
import script from "./AllOrders.vue?vue&type=script&lang=js"
export * from "./AllOrders.vue?vue&type=script&lang=js"
import style0 from "./AllOrders.vue?vue&type=style&index=0&id=703a06a8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "703a06a8",
  null
  
)

export default component.exports